import { CustomilyUser } from '@/typings/user';

export enum EntityType {
    TEMPLATE = 0,
    LIBRARY = 1,
    DESIGN = 2,
    OPTION_SET = 3,
    PRODUCT = 4,
    STORE = 5,
    INTEGRATIONS = 6
}

export enum AccessMode {
    RESTRICTED = 0,
    FULL = 1
}

export enum AccessRestriction {
    LISTED = 0, // Only explicitly assigned templates
    FULL_ACCESS = 1, // All templates without restrictions
    ALL_READ_ONLY_PLUS_LISTED = 2 // Read all, edit listed
}

export enum AccessLevelType {
    NONE = 0,
    LIST = 1 << 0,
    READ = 1 << 1,
    WRITE = 1 << 2,
    DELETE = 1 << 3,
    FULL = (1 << 4) - 1
}

export interface UserPermission {
    entityType: EntityType;
    entityIds: string[];
    accessLevel: AccessLevelType;
}

export interface TeamMember {
    user: CustomilyUser;
    accessMode: AccessMode;
    accessRestriction?: AccessRestriction;
}

export interface TeamMemberList {
    teamMembers: TeamMember[];
    totalCount: number;
}

export interface EntityData {
    id: string;
    name: string;
    thumbnail: string;
    isChecked?: boolean;
}
